import { apiClient, unwrap } from '@services/api';
import type { GeoValidationResult, ServiceArea } from '@/types';

export const geoService = {
  async getServiceAreas(): Promise<ServiceArea[]> {
    const res = await apiClient.get<ServiceArea[]>('/wholesaler/service-areas');
    return unwrap(res);
  },

  async createServiceArea(data: Partial<ServiceArea>): Promise<ServiceArea> {
    const res = await apiClient.post<ServiceArea>('/wholesaler/service-area', {
      ...data,
      minOrderTotal: data.minOrderTotal ?? data.minOrderAmount,
    });
    return unwrap(res);
  },

  async updateSchedule(id: string, data: Partial<ServiceArea>): Promise<ServiceArea> {
    const res = await apiClient.patch<ServiceArea>(`/wholesaler/service-area/${id}/schedule`, {
      deliveryDays: data.deliveryDays,
      deliveryHours: data.deliveryHours,
      deliveryFee: data.deliveryFee,
      minOrderTotal: data.minOrderTotal ?? data.minOrderAmount,
      freeDeliveryThreshold: data.freeDeliveryThreshold,
    });
    return unwrap(res);
  },

  async deleteServiceArea(id: string): Promise<void> {
    await apiClient.delete(`/wholesaler/service-area/${id}`);
  },

  async getNeighborhoods(city: string, district: string): Promise<string[]> {
    const res = await apiClient.get<string[]>(
      `/neighborhoods/${encodeURIComponent(city)}/${encodeURIComponent(district)}`,
    );
    return unwrap(res);
  },

  async updateLocation(data: {
    city?: string;
    district?: string;
    neighborhood?: string;
    latitude?: number;
    longitude?: number;
    address?: string;
  }): Promise<void> {
    await apiClient.post('/user/location', data);
  },

  async validateWholesaler(wholesalerId: string): Promise<GeoValidationResult | null> {
    const res = await apiClient.get<GeoValidationResult | null>(`/geo/validate/${wholesalerId}`);
    return unwrap(res);
  },
};
